import React, { useMemo } from "react"

import { SelectableCampaignActionCard } from "@/components/CampaignActionCardSelect/SelectableCampaignActionCard"
import { useStyles } from "@/components/CampaignActionCardSelect/styles"
import { CampaignType } from "@/types/djangio"
import { listCampaignTypeItemsForNewCampaignForm } from "@/services/campaigns"

interface CampaignActionCardSelectProps {
    value: number[]
    onChange: (value: number[]) => void
}

const MAX_SELECTION = 3
export const MIN_SELECTION = 2

const TYPES_ENABLED_FOR_MULTI_ACTION = listCampaignTypeItemsForNewCampaignForm().filter(
    (campaignType) => campaignType.in_multi_action_campaign,
) as unknown as CampaignType[]

export const CampaignActionCardSelect = (props: CampaignActionCardSelectProps) => {
    const { classes } = useStyles()

    const handleOptionClick = (campaignTypeValue: number) => {
        const isAlreadySelected = props.value.includes(campaignTypeValue)

        if (reachedMaxSelection && !isAlreadySelected) return

        if (isAlreadySelected) return props.onChange(props.value.filter((value) => value !== campaignTypeValue))
        return props.onChange([...props.value, campaignTypeValue])
    }

    const reachedMaxSelection = useMemo(() => props.value.length >= MAX_SELECTION, [props.value])

    return (
        <div className={classes.container}>
            {TYPES_ENABLED_FOR_MULTI_ACTION.sort((a, b) => a.order - b.order).map((campaignType, index) => {
                const isSelected = props.value.includes(campaignType.value)
                return (
                    <SelectableCampaignActionCard
                        key={index}
                        name={campaignType.key}
                        title={campaignType.label}
                        icon={campaignType.new_icon}
                        iconFamily={campaignType.icon_family}
                        description={campaignType.minimal_tip}
                        onClick={() => handleOptionClick(campaignType.value)}
                        isSelected={isSelected}
                        isDisabled={!isSelected && reachedMaxSelection}
                        orderSelected={props.value.indexOf(campaignType.value) + 1}
                    />
                )
            })}
        </div>
    )
}
